import { ColumnsType } from 'antd/es/table';
import { YColumnsType } from '@ydistri/ds';
import YPickLoginQrCodePopup from './YPickLoginQrCodePopup';
import { computeRemSize } from '@ydistri/theme';

export interface StoreDepartmentCredentials {
  storeId: number;
  store: {
    id: number;
    customerStoreId: string;
    name: string;
    code: string;
  };
  department: {
    id: number;
    customerDepartmentId: string;
    name: string;
  };
  storeTypeName: string;
  regionName: string;
  fileName: string;
}

/**
 * Instruct the browser to download a blob as a file
 * @param blob Blob retrieved from the API using Axios
 * @param filename Name of the file to save the blob as
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob); // Create temporary URL
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the object URL
  URL.revokeObjectURL(url);
};

export const getStoreDepartmentYPickCredentialsColumns = (
  hasDepartments: boolean,
  storeColumns: ColumnsType<StoreDepartmentCredentials>,
): YColumnsType<StoreDepartmentCredentials>[] => {
  const response: YColumnsType<StoreDepartmentCredentials>[] = [...storeColumns];

  if (hasDepartments) {
    response.push({
      title: 'Department',
      dataIndex: ['department', 'name'],
      key: 'departmentName',
      sorter: (a, b) => a.department.name.localeCompare(b.department.name),
      filterSearch: true,
      filters: [],
      showSorterTooltip: false,
      apiFilterable: true,
      apiFilterType: 'text',
    });
  }

  response.push({
    title: 'Store type',
    dataIndex: 'storeTypeName',
    key: 'storeTypeName',
    showSorterTooltip: false,
    width: computeRemSize(170),
    ellipsis: true,
    sorter: (a, b) => a.storeTypeName.localeCompare(b.storeTypeName),
    hideable: true,
    apiFilterable: true,
    apiFilterType: 'text',
  });

  response.push({
    title: 'Region',
    dataIndex: 'regionName',
    key: 'regionName',
    showSorterTooltip: false,
    width: computeRemSize(170),
    ellipsis: true,
    sorter: (a, b) => a.regionName.localeCompare(b.regionName),
    hideable: true,
    apiFilterable: true,
    apiFilterType: 'text',
  });

  response.push({
    title: 'Login QR Code',
    key: 'qrCodeImage',
    width: computeRemSize(120),
    align: 'center',
    render: (record: StoreDepartmentCredentials) => {
      return <YPickLoginQrCodePopup storeId={record.storeId} fileName={record.fileName} />;
    },
  });

  return response;
};
